import React, { useContext } from 'react';

import { Anchor } from '@zooplus/ui-components';

import AppContext from '../../context';
import { UiCategory } from '../../types';
import { LinkTypeEnum } from '../Link/Link';

import styles from './CategoryFlyout.module.scss';

const TopBrandsFlyout = ({
    category,
}: {
    category: UiCategory;
}): React.JSX.Element => {
    const { title, path, children } = category;
    const { translations } = useContext(AppContext);
    const viewAllLabel = translations.get('shop.header.categories.title.link');

    return (
        <div className={styles.scrollBox}>
            <div className={styles.flyOutHeader}>
                <Anchor
                    href={path}
                    data-link-type={LinkTypeEnum.PRIMARY}
                    data-zta="category-flyout-topBrands-level2-link">
                    {viewAllLabel} {title}
                </Anchor>
            </div>
            <ul
                id="header-category-flyout-topBrands-level3-links"
                className={styles.topBrandsPanel}>
                {children?.map((item) => (
                    <li key={item.title} className={styles.groupItem}>
                        <Anchor
                            data-zta="category-flyout-topBrands-level3-link"
                            key={item.title}
                            href={item.path}
                            data-link-type={LinkTypeEnum.NEUTRAL}
                            variant={LinkTypeEnum.NEUTRAL}>
                            {item.title}
                        </Anchor>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default TopBrandsFlyout;
